/* eslint-disable import/prefer-default-export */

import md5 from 'md5';
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';

const languages = {
  SE: 'sv',
  DK: 'da',
  NO: 'nb',
  FI: 'fi'
};

const LOCAL_STORAGE_KEY = 'gh.adminGc.';
const AUTH_KEY = `${LOCAL_STORAGE_KEY}auth`;

const parseJwt = (token) => jwt_decode(token);
// const base64Url = token.split('.')[1];
// const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
// const jsonPayload = decodeURIComponent(
//   atob(base64)
//     .split('')
//     .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
//     .join('')
// );

// return JSON.parse(jsonPayload);
export const storeTokenData = (token) => {
  // console.log('storeTokenData');
  const tokenData = parseJwt(token);
  localStorage.setItem(
    AUTH_KEY,
    JSON.stringify({
      gId: tokenData.gId,
      name: tokenData.name,
      country: tokenData.country,
      language: tokenData.language,
      expires: tokenData.expires,
      token
    })
  );
};

export const clearTokenData = () => {
  localStorage.removeItem(AUTH_KEY);
};

export const getToken = () => {
  const tokenData = localStorage.getItem(AUTH_KEY);
  if (!tokenData) return null;
  return JSON.parse(tokenData).token;
};

export const getTokenData = () => {
  const tokenData = localStorage.getItem(AUTH_KEY);
  if (!tokenData) return null;
  const token = JSON.parse(tokenData);
  return parseJwt(token.token);
};

export const getIdAndHashForAdmin = () => {
  const tokenData = getTokenData();
  if (!tokenData) return null;
  const hash = md5(tokenData.gId + tokenData.name + tokenData.salt);
  return { id: tokenData.gId, hash };
};

export const getIdAndHashForWebSale = () => {
  const tokenData = getTokenData();
  if (!tokenData) return null;
  const hash = md5(`EXTGHSALTED${tokenData.gId}EXTGHSALTED`);
  return { id: tokenData.gId, hash };
};

export const getLoginUrl = (redirectPage) => {
  const data = getIdAndHashForAdmin();
  if (!data) return null;
  // eslint-disable-next-line max-len
  return `https://www.golfamore.com/golfclub-admin/login/?login=1&id=${data.id}&hash=${data.hash}&redirect=${redirectPage}`;
};

export const getVolumeDealsUrl = () => {
  const tokenData = getTokenData();
  if (tokenData) {
    const hash = md5(tokenData.gId + tokenData.name);
    return `http://www.volumedeals.se/admin/login.php?login=1&id=${tokenData.gId}&hash=${hash}`;
  }
  return null;
};

export const getPlusUrl = () => {
  const tokenData = getTokenData();
  if (tokenData) {
    let language = getLanguage();
    language = ['sv', 'dk', 'no'].includes(language) ? language : 'en';
    const hash = md5(tokenData.gId + tokenData.name);
    return `https://golfhaftetplus.se/${language}/backend/login.php?login=1&id=${tokenData.gId}&hash=${hash}`;
  }
  return null;
};

export const isSuperAdmin = () => {
  const tokenData = getTokenData();
  return tokenData?.roles.includes('SuperAdmin');
};

export const getCountry = () => {
  const tokenData = getTokenData();
  return tokenData?.country;
};

export const getLanguage = () => {
  const isLocal = process.env.REACT_APP_ENVIRONMENT === 'local';
  const defaultLang = isLocal ? 'sv' : 'en';
  const tokenData = getTokenData();
  // console.log('tokenData', tokenData, languages[tokenData?.country]);
  return languages[tokenData?.country] || defaultLang;
};

export const getAffinities = () => {
  const tokenData = getTokenData();
  return tokenData?.affinities;
};

const fallbackCopyTextToClipboard = (text) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  let result;
  try {
    document.execCommand('copy');
    result = true;
  } catch (err) {
    result = false;
  }

  document.body.removeChild(textArea);
  return result;
};

export const copyTextToClipboard = (text) => {
  if (!navigator.clipboard) {
    return fallbackCopyTextToClipboard(text);
  }

  return navigator.clipboard.writeText(text).then(
    () => true,
    () => false
  );
};

export function setWithExpiry(key, value, ttl) {
  const item = {
    value,
    expiry: new Date().getTime() + ttl
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key) {
  const itemString = window.localStorage.getItem(key);
  if (!itemString) return null;

  const item = JSON.parse(itemString);
  const isExpired = new Date().getTime() > item.expiry;

  if (isExpired) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}
